import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const getSettings = async () => {
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const URL = routes.GET_MARGIN;
    const response = await axios.get(URL, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

export default getSettings;